export default class Games {
    static roleName(role) {
        switch (role) {
            case "gm":
            case 4:
                return t("Game Master");
            case "assistant":
            case 3:
                return t("Assistant Game Master");
            case "trusted":
            case 2:
                return t("Trusted Player");
            case "player":
            case 1:
            default:
                return t("Player");
        }
    }

    static roleImg(role) {
        switch (role) {
            case "gm":
            case 4:
                return "/images/dice/red-d20.png";
            case "assistant":
            case 3:
                return "/images/dice/cyan-d12.png";
            case "trusted":
            case 2:
                return "/images/dice/purple-d10.png";
            case "player":
            case 1:
            default:
                return "/images/dice/green-d8.png";
        }
    }
}
